const GridEditIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.66683 15.1666H6.00016C2.38016 15.1666 0.833496 13.62 0.833496 9.99998V5.99998C0.833496 2.37998 2.38016 0.833313 6.00016 0.833313H10.0002C13.6202 0.833313 15.1668 2.37998 15.1668 5.99998V7.33331C15.1668 7.60665 14.9402 7.83331 14.6668 7.83331C14.3935 7.83331 14.1668 7.60665 14.1668 7.33331V5.99998C14.1668 2.92665 13.0735 1.83331 10.0002 1.83331H6.00016C2.92683 1.83331 1.8335 2.92665 1.8335 5.99998V9.99998C1.8335 13.0733 2.92683 14.1666 6.00016 14.1666H6.66683C6.94016 14.1666 7.16683 14.3933 7.16683 14.6666C7.16683 14.94 6.94016 15.1666 6.66683 15.1666Z"
      fill="currentColor"
    />
    <path
      d="M14.6668 6.16669H1.35352C1.08018 6.16669 0.853516 5.94002 0.853516 5.66669C0.853516 5.39335 1.08018 5.16669 1.35352 5.16669H14.6668C14.9402 5.16669 15.1668 5.39335 15.1668 5.66669C15.1668 5.94002 14.9402 6.16669 14.6668 6.16669Z"
      fill="currentColor"
    />
    <path
      d="M8.00016 10.8333H1.35352C1.08018 10.8333 0.853516 10.6066 0.853516 10.3333C0.853516 10.06 1.08018 9.83331 1.35352 9.83331H8.00016C8.2735 9.83331 8.50016 10.06 8.50016 10.3333C8.50016 10.6066 8.2735 10.8333 8.00016 10.8333Z"
      fill="currentColor"
    />
    <path
      d="M5.67334 15.16C5.40001 15.16 5.17334 14.9333 5.17334 14.66V1.34668C5.17334 1.07335 5.40001 0.84668 5.67334 0.84668C5.94667 0.84668 6.17334 1.07335 6.17334 1.34668V14.66C6.17334 14.9333 5.95334 15.16 5.67334 15.16Z"
      fill="currentColor"
    />
    <path
      d="M10.3398 8.49333C10.0665 8.49333 9.83984 8.26666 9.83984 7.99333V1.34668C9.83984 1.07335 10.0665 0.84668 10.3398 0.84668C10.6132 0.84668 10.8398 1.07335 10.8398 1.34668V7.99333C10.8398 8.26666 10.6198 8.49333 10.3398 8.49333Z"
      fill="currentColor"
    />
    <path
      d="M9.8399 15.1666C9.5599 15.1666 9.30656 15.0666 9.11989 14.8799C8.89323 14.6599 8.79324 14.3333 8.84658 13.9933L8.9999 12.9333C9.03323 12.68 9.18656 12.3733 9.37323 12.1866L12.1399 9.41996C12.4999 9.05996 12.8532 8.87329 13.2266 8.83329C13.6866 8.78663 14.1466 8.98663 14.5799 9.41996C15.0132 9.8533 15.2132 10.3066 15.1666 10.7733C15.1332 11.1466 14.9399 11.5 14.5799 11.86L11.8132 14.6266C11.6332 14.8066 11.3265 14.96 11.0665 15L10.0132 15.1533C9.95324 15.1599 9.89324 15.1666 9.8399 15.1666ZM13.3466 9.83329C13.3399 9.83329 13.3266 9.83329 13.3199 9.83329C13.1866 9.84663 13.0266 9.94659 12.8399 10.1333L10.0732 12.8999C10.0399 12.9333 9.99322 13.0333 9.98655 13.08L9.83323 14.1399L10.9199 14.02C10.9666 14.0133 11.0666 13.96 11.0999 13.9333L13.8666 11.1666C14.0532 10.98 14.1532 10.82 14.1666 10.6866C14.1799 10.5333 14.0799 10.3533 13.8666 10.1399C13.6666 9.93327 13.4932 9.83329 13.3466 9.83329Z"
      fill="currentColor"
    />
    <path
      d="M13.8269 12.4067C13.7802 12.4067 13.7402 12.4 13.6935 12.3866C12.6935 12.1066 11.8935 11.3066 11.6135 10.3066C11.5402 10.04 11.6935 9.76669 11.9602 9.69335C12.2335 9.62002 12.5002 9.77337 12.5735 10.04C12.7602 10.7067 13.2935 11.24 13.9602 11.4267C14.2269 11.5 14.3802 11.78 14.3069 12.04C14.2469 12.2667 14.0402 12.4067 13.8269 12.4067Z"
      fill="currentColor"
    />
  </svg>
);
export default GridEditIcon;
